import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const NODE_ENDPOINT = 'node';
export const NODE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NODE_ENDPOINT);

export const nodeStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
